import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { Actions } from '../Modal';
import { Form, Input, MenuSelect, Submit } from '../Form'
import { createStudent, editStudent } from '../../features/students/studentsSlice'

const properties = { id: '', codigo: '', nombre: '', idEstatus: '', estatus: '', genero: '', etnia: '', idCalendario: '', calendario: '', idSede: '', sede: '', carrera: '', idArea: '' }

const Forms = ({ isRoot }) => {
    const { students } = useSelector(state => state.students);
    const { id, openModalEdit } = useSelector(state => state.modal);
    const { campus } = useSelector(state => state.campus);
    const { calendars } = useSelector(state => state.calendars);
    const { careers } = useSelector(state => state.careers);

    const types = [{id: 1, nombre: 'Alumno'}, {id: 2, nombre: 'Egresado'}, {id: 3, nombre: 'Inactivo'}]
    const genders = [ { id: 'H', nombre: 'Hombre' }, { id: 'M', nombre: 'Mujer' }]
    const ethnicity = [ { id: '1', nombre: 'Indigena' }, { id: '0', nombre: 'No' }]
    const data = openModalEdit ? students.find(el => el.id === id) : properties;
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true });

    const onSubmit = values => dispatch(openModalEdit ? editStudent({ id, values, setError: methods.setError }) : createStudent({ values, setError: methods.setError }))

    return(
        <Actions title={ openModalEdit ? 'Editar' : 'Nuevo Estudiante' }>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input min={7} max={9} name="codigo" label={'Código'} regEx={/[0-9A-Z]/g} val={data.codigo} size={3} />
                    <Input name={'nombre'} label={'Nombre'} size={9} val={ data.nombre } />
                    <MenuSelect name={'estatus'} label="Estatus" options={types} val={ data.idEstatus} />
                    <MenuSelect name={'genero'} label="Sexo" options={genders} size={6} val={data.genero} />
                    <MenuSelect name={'etnia'} label="Etnia" options={ethnicity} size={6} val={data.etnia} />
                    <MenuSelect name={'calendario'} label="Calendario Escolar" options={calendars} size={6} val={data.idCalendario} />
                    <MenuSelect name={'sede'} label="Sede" options={campus} size={6} val={data.idSede} />
                    { isRoot ?
                        <MenuSelect name={'carrera'} label="Carrera" options={careers} val={data.idArea} />
                    : null }
                    <Submit title={ openModalEdit ? 'Guardar cambios' : 'Registrar' } />
                </Grid>
            </Form>
        </Actions>
    )
}

export default Forms;